function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { ref, defineComponent, getCurrentInstance } from "vue";
import { leaveMessage } from "@pt/api/user/index";
export default defineComponent({
    props: {
        description: {
            type: String
        },
        content: {
            type: String
        }
    },
    components: {},
    setup: function setup(props, param) {
        var emit = param.emit;
        var handleCancel = // const feedbackValue = computed({
        //   get() {
        //     return props.content
        //   },
        //   set(val) {
        //     emit('update:content', val)
        //   },
        // })
        function handleCancel() {
            emit("cancel");
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var loading = ref(false);
        var feedbackValue = ref("");
        function handleSubmit() {
            return _handleSubmit.apply(this, arguments);
        }
        function _handleSubmit() {
            _handleSubmit = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            loading.value = true;
                            _ctx.next = 4;
                            return leaveMessage({
                                content: feedbackValue.value
                            });
                        case 4:
                            res = _ctx.sent;
                            if (res.data.code === 0) {
                                root.$message.success(String(root.$t("playTurbo.trial.totop.contact.dialog.success")));
                                emit("success");
                            }
                            _ctx.next = 11;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                        case 11:
                            loading.value = false;
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        8
                    ]
                ]);
            }));
            return _handleSubmit.apply(this, arguments);
        }
        return {
            loading: loading,
            feedbackValue: feedbackValue,
            handleCancel: handleCancel,
            handleSubmit: handleSubmit
        };
    }
});
